import React, { FC, PropsWithChildren } from "react";
import { FormControl as MuiFormControl, type FormControlProps } from "@mui/material";

const FormControl: FC<PropsWithChildren<FormControlProps>> = ({
  children,
  ...props
}) => <MuiFormControl {...props}>{children}</MuiFormControl>;

export default FormControl;
